// extracted by mini-css-extract-plugin
export var currencyInput = "_kg-1";
export var currencySymbol = "_kg-0";